import { render } from "./Editor.vue?vue&type=template&id=6386ba8c&scoped=true"
import script from "./Editor.vue?vue&type=script&lang=js"
export * from "./Editor.vue?vue&type=script&lang=js"

import "./Editor.vue?vue&type=style&index=0&id=6386ba8c&scoped=true&lang=css"
import "./Editor.vue?vue&type=style&index=1&id=6386ba8c&lang=css"

import exportComponent from "/codebuild/output/src1198/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6386ba8c"]])

export default __exports__